<template>
  <div class="search_constel_page">
    <div class="top_content">
      <!-- <header v-if="isWeaWvFullScreen">
        <div class="top_pad" :style="{ height: `${statusHeight}px` }"></div>
        <ul class="controls_container">
          <li class="header_left_col">
            <div class="header_back" @click="handleHeaderBackClick()"></div>
            <div>星座搜索</div>
          </li>
        </ul>
      </header> -->
      <div class="search_constel_input">
        <div class="search_constel_icon"></div>
        <div class="input_box">
          <input id="input_ele" class="input_ele" type="text" role="textbox"
            placeholder="搜索星座"
            v-model.trim="searchKey"
            @input="handleInputSearchKey($event)"
          />
        </div>
      </div>
    </div>

    <div class="search_constel_content">
      <div class="result_list_wrapper">
        <ul class="result_list">
          <template v-if="searchList.length > 0">
            <li v-for="constel in searchList" :key="constel.id" class="constel_info_wrapper"
              @click.stop="handleConstelRowClick(constel.id)"
            >
              <div class="constel_info">
                <div class="constel_left">
                  <div class="result_icon">
                    <img v-if="constel.icon" :src="constel.icon" alt="">
                  </div>
      
                  <div class="constel_data">
                    <div class="constel_name">{{ constel.name }}</div>
                    <div class="constel_en_name">拉丁名：{{ constel.latinName }}</div>
                  </div>
                </div>
                <div class="result_more_icon"></div>
              </div>
            </li>
          </template>
          <li v-else class="constel_info_wrapper no_match_constel">
            无匹配星座
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import constelsData from '../constant/constelsData.js'; // 星座数据
import utils from '../utils/index.js';

export default {
  data() {
    return {
      constels: constelsData.constels,
      searchPhl: '搜索星座',
      searchKey: '',
      searchList: constelsData.constels,
      isWeaWvFullScreen: false,
      statusHeight: 24
    }
  },
  beforeMount() {
    this.statusHeight = utils.jsbGetStatusHeight();
    this.isWeaWvFullScreen = utils.isWeaWvFullScreen();
  },
  mounted() {},
  methods: {
    handleConstelRowClick(id) {
      setTimeout(() => {
        this.$router.push({
          path: '/constels',
          query: {
            ...this.$route.query,
            constelId: id
          }
        });
      }, 300);
    },
    handleInputSearchKey(e) {
      const value = this.searchKey;

      if (value) {
        const searchResult = this.constels.filter(item => item.name.includes(value));
        this.searchList = searchResult;
      } else {
        this.searchList = this.constels;
      }
    },
    handleHeaderBackClick() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang='scss'>
.search_constel_page {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #151A59;
  width: 100%;
  height: 100%;
  .top_pad {
    height: 24px;
  }
  .controls_container {
    height: 48px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .header_left_col {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      font-size: 20px;
      font-family: HarmonyOS_Sans_SC_Medium;
      color: rgba(255,255,255,0.9);
      line-height: 1;
      .header_back {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        background: url('../assets/images/icon/ic_title_return@2x.png') no-repeat;
        background-size: contain;
      }
    }
  }

  .search_constel_input {
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 40px;
    border-radius: 12px;
    padding: 0 0 0 10px;
    margin: 14px 16px 18px 16px;
    background-color: rgba(225, 225, 225, 0.1);

    .search_constel_icon {
      width: 20px;
      height: 20px;
      background: url('../assets/images/icon/ic_star_search@2x.png') no-repeat;
      background-size: contain;
    }
    .input_box {
      flex-grow: 1;
      display: flex;
      align-items: center;
      height: 100%;
    }
    .input_ele {
      display: block;
      width: 100%;
      height: 100%;
      background-color: transparent;
      margin: 0 8px 0 12px;
      border: none;
      outline: none;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 1;
      font-family: HarmonyOS_Sans_SC;
      color: #FFFFFF;
    }

    .input_ele::-webkit-input-placeholder {
      text-align: left;
      font-size: 14px;
      font-family: HarmonyOS_Sans_SC;
      color: #FFFFFF;
      line-height: 1;
    }
  }

  .search_constel_input::after {
    content: " ";
    width: 200%;
    height: 200%;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    border: 1px solid rgba(255,255,255,0.2);
    transform: scale(0.5);
    transform-origin: 0 0;
    box-sizing: border-box;
    border-radius: 24px;
  }

  .search_constel_content {
    flex-grow: 1;
    overflow-y: auto;
    border-radius: 12px;
    // padding: 12px 16px 0;
    padding: 0 16px 16px;
    box-sizing: border-box
  }

  .result_list_wrapper {
    border-radius: 12px;
    // padding: 12px 0;
    background-color: rgba(225, 225, 225, 0.1);
  }
  .result_list {
  }

  .constel_info_wrapper {
    padding: 0 12px;
  }
  .constel_info {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
  }
  .constel_info_wrapper:not(:last-child) {
    .constel_info::after {
      content: " ";
      width: 200%;
      height: 200%;
      position: absolute;
      top: 0;
      left: 0;
      border-bottom: 1px solid rgba(225, 225, 225, 0.3);
      transform: scale(0.5);
      transform-origin: 0 0;
      box-sizing: border-box;
    }
  }

  .no_match_constel {
    padding: 10px 12px;
    justify-content: center;
    color: #FFF;
  }

  .constel_left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .result_icon {
    width: 36px;
    height: 36px;
    background-size: contain;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .constel_data {
    margin-left: 12px;
  }
  .constel_name {
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC_Medium;
    color: rgba(255,255,255,0.9);
    line-height: 1;
  }
  .constel_en_name {
    margin: 8px 0 0 0;
    font-size: 12px;
    font-family: HarmonyOS_Sans_SC;
    color: rgba(255,255,255,0.6);
    line-height: 1;
  }
  .result_more_icon {
    width: 12px;
    height: 12px;
    background: url('../assets/images/icon/ic_arrow_more_white@2x.png') no-repeat;
    background-size: contain;
  }
}
</style>
